<div class="content-holder">
  <div class="header align-items-center">
    <p class="title">
      <span *transloco="let t">{{ t('profile.interculturalist_status') }}</span>
      @if(!initialLoading()){
          <span *transloco="let t; scope: interculturalistStatusTranslation().scope" class="text-muted ms-2">{{ t(interculturalistStatusTranslation().key) }}</span>
      }
    </p>
    <span class="badge badge-warning text-dark align-self-center" [style.opacity]="hasUnsavedChanges() ? 1 : 0" style="transition: opacity 0.3s ease-in-out;">
      {{ 'content_management.unsaved_changes' | transloco }}
    </span>
    <div class="subtitle" *transloco="let t; scope: 'profile'">
      {{ t('profile.status_page_subtitle') }}
    </div>
  </div>

  <div class="row body">
    <div class="col-12 mt-4">
      @if (error()) {
        <alert [type]="'danger'" [dismissible]="true" class="mb-4">
          <span [innerHTML]="error()! | transloco"></span>
        </alert>
      }

      @if (initialLoading()) {
        <div class="d-flex justify-content-center py-4">
          <multisite-loader-globe-animation-detail [width]="80" [height]="80" class="my-3"></multisite-loader-globe-animation-detail>
        </div>
      } @else {
        <form [formGroup]="statusForm" class="w-100" (ngSubmit)="saveStatus()">
          <section class="status-section status-section-highlight">
            <div class="section-copy">
              <h2 *transloco="let t; scope: 'profile'">{{ t('profile.are_you_interculturalist') }}</h2>
              <p class="mb-0" *transloco="let t; scope: 'profile'">{{ t('profile.interculturalist_definition') }}</p>
            </div>

            <div class="form-check form-switch toggle-row" *transloco="let t">
              <span class="toggle-label">{{ t('common.no') }}</span>
              <input class="form-check-input" id="self_assessment" type="checkbox" formControlName="self_assessment" />
              <label class="toggle-label" for="self_assessment">{{ t('common.yes') }}</label>
            </div>
          </section>

          <section class="status-section">
            <h2 *transloco="let t; scope: 'profile'">{{ t('profile.work_status_question') }}</h2>
            <div class="radio-grid">
              @for (option of workStatusOptions; track option.value) {
                <label class="radio-option" [class.is-disabled]="!statusForm.controls.self_assessment.value">
                  <input type="radio" formControlName="work_status" [value]="option.value" />
                  <span *transloco="let t; scope: 'profile'">{{ t(option.translationKey) }}</span>
                </label>
              }
            </div>
            <cco-common-form-validation-messages
              [control]="statusForm.controls.work_status"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </section>

          <section class="status-section">
            <label class="form-label" for="statement" *transloco="let t; scope: 'profile'">
              {{ t('profile.my_activity_my_words') }}
            </label>
            <textarea
              id="statement"
              class="form-control input-lg"
              formControlName="statement"
              rows="6"
            ></textarea>
            <div class="d-flex justify-content-between form-text text-muted">
              <span *transloco="let t; scope: 'profile'">{{ t('profile.my_activity_my_words_help') }}</span>
              <span>{{ statusForm.controls.statement.value.length }}/750</span>
            </div>
            <cco-common-form-validation-messages
              [control]="statusForm.controls.statement"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </section>

          <section class="status-section">
            <multisite-tracking-completeness-status-card
              [isComplete]="statusCompletenessMet()"
              [titleTranslationKey]="'profile.interculturalist_eligibility'"
              [titleTranslationScope]="'profile'"
              [descriptionTranslationKey]="'profile.interculturalist_eligibility_requirements_pending'"
              [descriptionTranslationScope]="'profile'"
              [completeBadgeTranslationKey]="'profile.status_eligibility_complete'"
              [completeBadgeTranslationScope]="'profile'"
              [incompleteBadgeTranslationKey]="'profile.status_eligibility_incomplete'"
              [incompleteBadgeTranslationScope]="'profile'"
              [requirements]="completenessRequirementItems()"
            ></multisite-tracking-completeness-status-card>

            @if (!linkRequirementMet()) {
              <p class="guidance-copy mb-0" *transloco="let t; scope: 'profile'">
                {{ t('profile.status_links_guidance') }}
                <a routerLink="/professional/links">{{ t('profile.status_links_cta') }}</a>
              </p>
            }
          </section>

          <section class="status-section timeline-section">
            <h2 *transloco="let t; scope: 'profile'">{{ t('profile.review_noun') }}</h2>

            <ul class="timeline-list">
              <li class="timeline-item" [class.is-active]="reviewTimelineState() === 'draft'" [class.is-complete]="reviewTimelineState() !== 'draft'">
                <div class="timeline-marker">1</div>
                <div class="timeline-content">
                  <h3 *transloco="let t;scope:'profile'">{{ t('profile.request_noun') }}</h3>
                  @if(!isInterculturalist()) {
                    @if (interculturalistProfile()?.reviewRequestedAt) {
                        <p class="mb-0" *transloco="let t; scope: 'profile'">{{ t('profile.requested') }} {{ interculturalistProfile()?.reviewRequestedAt | date: 'longDate' }}</p>
                    } @else {
                        <p class="mb-0" *transloco="let t; scope: 'profile'">{{ t('profile.status_request_step_help') }}</p>
                    }
                  }
                </div>
              </li>

              <li class="timeline-item" [class.is-active]="reviewTimelineState() === 'requested' || reviewTimelineState() === 'in_review'" [class.is-complete]="reviewTimelineState() === 'completed'">
                <div class="timeline-marker">2</div>
                <div class="timeline-content">
                  <h3 *transloco="let t;scope:'profile'">{{ t('profile.review_noun') }}</h3>
                  @if(!isInterculturalist()) {

                    @if (reviewTimelineState() === 'requested') {
                        <p class="mb-0" *transloco="let t;scope:'profile'">{{ t('profile.awaiting_review') }}</p>
                    }
                    @if (reviewTimelineState() === 'in_review') {
                        <p class="mb-0" *transloco="let t;scope:'profile'">
                        {{ t('profile.review_started') }} {{ interculturalistProfile()?.reviewStartedAt | date: 'longDate' }}
                        </p>
                    }
                    @if (reviewTimelineState() === 'draft') {
                      <p class="mb-0 text-muted" *transloco="let t; scope: 'profile'">{{ t('profile.status_review_step_help') }}</p>
                    }
                  }

                  @if (canWithdrawReview()) {
                    <button class="btn btn-link px-0 mt-2" type="button" (click)="toggleReviewRequest()" *transloco="let t; scope: 'profile'">
                      {{ t('profile.withdraw_request') }}
                    </button>
                  }
                </div>
              </li>

              <li class="timeline-item" [class.is-active]="reviewTimelineState() === 'completed'">
                <div class="timeline-marker">3</div>
                <div class="timeline-content">
                  <h3 *transloco="let t;scope:'profile'">{{ t('profile.result') }}</h3>

                 @if(!isInterculturalist()) {
                     @if (reviewTimelineState() !== 'completed') {
                        <p class="mb-0 text-muted" *transloco="let t; scope: 'profile'">{{ t('profile.status_result_step_help') }}</p>
                    }

                    @if (reviewOutcome() === 'not_approved') {
                        <p class="mb-0" *transloco="let t; scope: 'profile'">
                            <strong class="text-danger me-2">{{ t('profile.unsuccessful') }}</strong>
                            {{ t('profile.more_interculturalism_needed') }}
                        </p>
                        @let reviewerFeedback = interculturalistProfile()?.reviewerFeedback;
                        @if(reviewerFeedback) {
                            <p>

                              <span class="text-warning me-1" *transloco="let t">{{ t('content.feedback') }}:</span>
                              {{ reviewerFeedback }}
                            </p>
                        }
                    }
                  }

                  @if (reviewOutcome() === 'approved') {
                    <p class="mb-0" *transloco="let t; scope: 'profile'">{{ t('profile.interculturalist_status_approved') }}</p>
                  }

                  @if (reviewOutcome() === 'pre_approved') {
                    <p class="mb-0" *transloco="let t; scope: 'profile'">{{ t('profile.interculturalist_status_pre_approved') }}</p>
                  }
                    @if (reviewOutcome() === 'skipped') {
                    <p class="mb-0" *transloco="let t; scope: 'profile'">{{ t('profile.interculturalist_status_skipped') }}</p>
                  }
                </div>
              </li>
            </ul>
          </section>

          <div class="input-self">
            <div class="input-group my-3">
              @if (isAnythingLoading()) {
                <div class="d-flex justify-content-center w-100">
                  <multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail>
                </div>
              } @else {
                <button class="btn btn-lg btn-primary w-100" [disabled]="statusForm.invalid" type="submit">
                  {{ 'common.save_changes' | transloco }}
                </button>
              }
            </div>
          </div>
        </form>

        <section class="status-actions">
          @if (canRequestReview()) {
            <button class="btn btn-lg btn-outline-primary w-100" type="button" (click)="toggleReviewRequest()">
              @if (reviewTimelineState() === 'completed' && !isInterculturalist()) {
                <span *transloco="let t; scope:'profile'">{{t('profile.request_review_again')}}</span>
              } @else {
                <span *transloco="let t">{{t('common.request_verb')}}</span>
              }
            </button>
          } @else if (reviewTimelineState() === 'draft' || (reviewTimelineState() === 'completed' && !isInterculturalist())) {
            <button class="btn btn-lg btn-outline-primary w-100" type="button" [disabled]="true" *transloco="let t">
              @if (reviewTimelineState() === 'completed' && !isInterculturalist()) {
                <span *transloco="let t; scope:'profile'">{{t('profile.request_review_again')}}</span>
              } @else {
                <span *transloco="let t">{{t('common.request_verb')}}</span>
              }
            </button>
          }
        </section>
      }
    </div>
  </div>
</div>